import { useContext, useState, useEffect } from "react";
import "./App.css";
import Loader from "../src/shared/Loader/Loader";
import { CommonContext } from "./context/CommonContext";
import Router from "./routes/routes";
import AlertBox from "./shared/AlertBox/AlertBox";
import AlertSuccess from "./shared/AlertSuccess/AlertSuccess";
import Useportrait from "./Component/Useportrait";

function App() {
  const { isLoading } = useContext(CommonContext);
  const isPortrait = Useportrait();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      const isMobileDevice =
        /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

      const isSmallScreen = window.innerWidth <= 1024;

      setIsMobile(isMobileDevice && isSmallScreen);
    };

    checkDevice();
    window.addEventListener("resize", checkDevice);

    return () => window.removeEventListener("resize", checkDevice);
  }, []);

  if (isMobile && !isPortrait) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "18px",
          fontWeight: "bold",
          textAlign: "center",
          padding: "20px",
        }}
      >
        Please rotate your device 📱
      </div>
    );
  }

  return (
    <>
      <Router />
      <Loader open={isLoading} />
      <AlertBox />
      <AlertSuccess />
    </>
  );
}

export default App;